import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "bg-blue-50 h-full rounded-l-lg flex flex-col" }
const _hoisted_2 = { class: "flex-shrink-0 h-14 bg-white flex justify-between items-center p-3 font-bold text-lg text-gray-600" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "已选课程列表", -1)
const _hoisted_5 = { class: "pt-1 px-2 pb-3 flex-grow overflow-y-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_f_icon = _resolveComponent("f-icon")!
  const _component_timetable_selected_course_card = _resolveComponent("timetable-selected-course-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("span", {
          class: "ml-2 h-5 f-clickable text-primary",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleClickCloud && _ctx.handleClickCloud(...args)))
        }, [
          _createVNode(_component_f_icon, {
            name: "cloud",
            width: 24,
            height: 20
          })
        ])
      ]),
      _createElementVNode("span", {
        class: "justify-self-end text-gray-500 h-4 f-clickable",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('click-back')))
      }, [
        _createVNode(_component_f_icon, {
          name: "right",
          width: 10,
          height: 16
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courses, (course) => {
        return (_openBlock(), _createBlock(_component_timetable_selected_course_card, {
          key: course.id,
          course: course,
          onClick: _ctx.handleClickCard,
          onDeleteCourse: _cache[2] || (_cache[2] = (courseId) => _ctx.$emit('delete-course', courseId)),
          onShowDetail: _cache[3] || (_cache[3] = (courseId) => _ctx.$emit('show-detail', courseId))
        }, null, 8, ["course", "onClick"]))
      }), 128))
    ])
  ]))
}